var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBetbookBackIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon betbook-back-button-icon",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "gray",
    clipPath: "url(#betbook-back-icon-sv_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16 30.5c8.008 0 14.5-6.492 14.5-14.5S24.008 1.5 16 1.5 1.5 7.992 1.5 16 7.992 30.5 16 30.5zm0 1.5c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.738 10.18a.75.75 0 00-1.057.082l-4.498 5.247a.747.747 0 000 .982l4.498 5.247.078.079a.75.75 0 00.98.003l.078-.079a.75.75 0 00.002-.98l-3.438-4.011H23.25a.75.75 0 000-1.5H10.38l3.44-4.012.065-.09a.75.75 0 00-.147-.967z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "betbook-back-icon-sv_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}

export default SvgBetbookBackIconSv;